var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gi-title",class:{'is-light': _vm.theme==='light'}},[(_vm.data.h1)?_c('h1',[_c('span',[_vm._v(_vm._s(_vm.data.h1))])]):_vm._e(),(_vm.data.h2)?_c('h2',[_vm._v(_vm._s(_vm.data.h2))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }